export const createFootnoteHtml = (html: string) => {
  return `<div style="max-height: 40vh; min-width: 200px; overflow-y: auto; font-weight: 400">${html}</div>`
}
